<template>
  <span v-if="!choice.hidden">
    <span v-if="hasProps">
      <span
        :id="choiceId"
        @click="select"
        :class="[{ highlight: selected }, cssClass]"
        :style="{
          backgroundColor: choice.bgcolor,
          backgroundImage: 'url('+choice.background+')',
          }"
        :data-price="choice.overrides.price"
        :data-humancolor="choice.humancolor"
        :data-sku="choice.overrides.sku">&nbsp;
      </span>
      <b-tooltip :target="choiceId">
        {{ choice.title }} - ${{ choice.overrides.price.toFixed(2) }}
        <div v-if="extraTooltip">{{ extraTooltip }}</div>
      </b-tooltip>
    </span>
    <span v-else class="spacer">
      &nbsp;
    </span>
  </span>
</template>

<script>
import { mapState } from 'vuex';
import { overlay } from '@/utils';

export default {
  name: 'OptionChoiceColor',
  components: {},
  props: {
    choice: Object,
    optionName: String,
  },
  data() {
    return {
    };
  },
  computed: {
    hasProps() {
      return Object.keys(this.choice).length > 0;
    },
    choiceId() {
      return `select-${this.choice.name}`;
    },
    selected() {
      return this.product.color === this.choice.name;
    },
    cssClass() {
      let retval = this.choice.cssclass;
      if (this.choice.outofstock) {
        retval = 'colorselectoos';
      }
      return retval;
    },
    extraTooltip() {
      let retval = false;
      if (this.choice.outofstock) {
        retval = `OUT OF STOCK ${this.choice.outofstock}`;
      }
      return retval;
    },
    ...mapState(['product']),
  },
  methods: {
    select() {
      if (!this.choice.outofstock) {
        console.log('select', this.choice.name);
        const newProduct = overlay(this.product, this.choice.overrides);
        this.$store.commit('setProduct', newProduct);
        // TODO: use setProductOptions instead?

        const designProp = {};
        designProp[this.optionName] = this.choice.name;
        this.$store.commit('setDesign', designProp);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.colorselectblock, .colorselectoos {
 display: inline-block;
 height: 1.5em;
 width: 2.8em;
 border: 2px solid #ddd0;
 background-size: cover;
 cursor: pointer;
 margin: 0.5px;
}

.colorselectoos {
  opacity: 0.8;
  border-color: silver;
  background-image:url('/resources/images/tool/oos.png') !important;
  background-position: center;
  cursor: not-allowed;
}

.colorselectblock.highlight, .colorselectoos.highlight {
  /* border-width: 2px; */
  border-color: gold;
}

.spacer {
  display: inline-block;
  width: 0.3rem;
}
</style>
